import React from 'react'
import {Icon} from '@chakra-ui/react'
const CloseLargerIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" cursor="pointer" fill="transparent" {...props}>
            <circle cx="20" cy="20" r="20" fill="currentColor" />
            <rect
                x="26.4072"
                y="14.6231"
                width="16.6666"
                height="1.45833"
                transform="rotate(135 26.4072 14.6231)"
                fill="white"
            />
            <rect
                x="26.4082"
                y="25.377"
                width="1.45833"
                height="16.6666"
                transform="rotate(135 26.4082 25.377)"
                fill="white"
            />
        </Icon>
    )
}

export default CloseLargerIcon
